import './GlobalFooter.scss';
import useLocale from '../../locale/useLocale';
import { MouseEvent, KeyboardEvent } from 'react';

const GlobalFooter = () => {
    const { l } = useLocale();
    const currentYear = new Date().getFullYear();
    const footerClick = (
        event: MouseEvent<HTMLSpanElement> | KeyboardEvent
    ) => {
        const target = event.currentTarget as HTMLSpanElement | null;
        if (target) {
            const url = target.getAttribute('data-url');
            if (url) {
                window.open(url, '_blank');
            }
        }
    };

    return (
        <div className="footer-wrapper text-center mt-5 p-1 overflow-hidden">
            <footer role="contentinfo" className="ap-footer d-inline-flex">
                <div
                    className="ap-footer-content m-3"
                    data-testid="footer-content"
                >
                    <span>{`© ${currentYear} ${l('_PwCDisclaimer1')}`}</span>
                    <span
                        onClick={footerClick}
                        onKeyDown={(
                            e: React.KeyboardEvent<HTMLSpanElement>
                        ) => {
                            if (e.key === 'Enter') {
                                footerClick(
                                    e as unknown as MouseEvent<HTMLSpanElement>
                                );
                            }
                        }}
                        data-url="https://www.pwc.com/gx/en/about/corporate-governance/network-structure.html"
                        className="footer-link"
                        tabIndex={0}
                    >
                        {`${l('_PwCDisclaimer2')}`}
                    </span>
                    <span>{`${l('_PwCDisclaimer3')}`}</span>
                </div>
            </footer>
        </div>
    );
};

export default GlobalFooter;
